// This constant needs to match the types in the Notification model in the Back-End >> "app/models/notification.rb"
const NotificationTypes = {
  alert: 'alert',
  info: 'info',
};

export default NotificationTypes;
